import { useState, useEffect, useRef } from "react";
import { Mic, Check } from "lucide-react";
import { toast } from "sonner";

// Local (per-browser) microphone / voice input device selector.
export function MicSelector() {
  const [devices, setDevices] = useState([]);
  const [selected, setSelected] = useState(localStorage.getItem("voiceInputDeviceId") || "");
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((t) => t.stop());
      const list = await navigator.mediaDevices.enumerateDevices();
      setDevices(list.filter((d) => d.kind === "audioinput"));
      setLoaded(true);
    } catch (e) {
      toast.error("Microfoontoegang geweigerd");
    }
  };

  const choose = (id) => {
    setSelected(id);
    if (id) localStorage.setItem("voiceInputDeviceId", id);
    else localStorage.removeItem("voiceInputDeviceId");
    toast.success("Voice-inputdevice opgeslagen");
  };

  return (
    <div className="max-w-lg rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="mic-settings">
      <div className="flex items-center gap-2 text-sm font-bold text-slate-900"><Mic style={{ width: 16, height: 16 }} /> Voice-inputdevice</div>
      <p className="mt-1 text-sm text-slate-500">Kies welke microfoon wordt gebruikt voor het inspreken van incidenten en notities. Handig als de dispatcher iemand aan de lijn heeft en een aparte (lokale) microfoon wil gebruiken. Deze keuze geldt per apparaat/browser.</p>

      <div className="mt-4 space-y-3">
        <button data-testid="load-mics" onClick={refresh} className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-700">
          <Mic className="h-4 w-4" /> {loaded ? "Vernieuwen" : "Microfoons laden"}
        </button>

        {loaded && (
          <div className="space-y-2">
            <button data-testid="mic-option-default" onClick={() => choose("")}
              className={`flex w-full items-center justify-between rounded-xl border px-3 py-2.5 text-left text-sm ${selected === "" ? "border-blue-500 bg-blue-50" : "border-slate-200"}`}>
              <span>Systeemstandaard</span>{selected === "" && <Check className="h-4 w-4 text-blue-600" />}
            </button>
            {devices.map((d, i) => (
              <button key={d.deviceId} data-testid={`mic-option-${i}`} onClick={() => choose(d.deviceId)}
                className={`flex w-full items-center justify-between rounded-xl border px-3 py-2.5 text-left text-sm ${selected === d.deviceId ? "border-blue-500 bg-blue-50" : "border-slate-200"}`}>
                <span className="truncate">{d.label || `Microfoon ${i + 1}`}</span>
                {selected === d.deviceId && <Check className="h-4 w-4 shrink-0 text-blue-600" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
